import { defaultStatus } from "../defaultState/defaultState";
import {
  ADD_FETCH_ALL_COUNT_ADMINS_FAILURE,
  ADD_FETCH_ALL_COUNT_ADMINS_REQUEST,
  ADD_FETCH_ALL_COUNT_ADMINS_SUCCESS,
  ADD_FETCH_ALL_COUNT_STAFF_FAILURE,
  ADD_FETCH_ALL_COUNT_STAFF_REQUEST,
  ADD_FETCH_ALL_COUNT_STAFF_SUCCESS,
  RESET_CURRENT_BLOCK,
  GET_PATIENT_COUNT_FAILURE,
  GET_PATIENT_COUNT_REQUEST,
  GET_PATIENT_COUNT_SUCCESS,
} from "./dashboardType";

const initialState = {
  currentBlock: null,
  fetchAdminCount: { ...defaultStatus },
  fetchStaffCount: { ...defaultStatus },
  formMode: null, 
  fetchPatientCount: { ...defaultStatus },
};

const DashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
  
    case ADD_FETCH_ALL_COUNT_ADMINS_REQUEST:
      return {
        ...state,
        fetchAdminCount: { ...state.fetchAdminCount, inProgress: true },
      };
    case ADD_FETCH_ALL_COUNT_ADMINS_SUCCESS:
      return {
        ...state,
        fetchAdminCount: {
          ...state.fetchAdminCount,
          success: true,
          inProgress: false,
          count: payload?.data
        },
      };
    case ADD_FETCH_ALL_COUNT_ADMINS_FAILURE:
      return {
        ...state,
        fetchAdminCount: {
          ...state.fetchAdminCount,
          error: true,
          inProgress: false,
          errorMessage: payload.error,
        },
      };

    
    case ADD_FETCH_ALL_COUNT_STAFF_REQUEST:
      return {
        ...state,
        fetchStaffCount: { ...state.fetchStaffCount, inProgress: true },
      };
    case ADD_FETCH_ALL_COUNT_STAFF_SUCCESS:
      return {
        ...state,
        fetchStaffCount: {
          ...state.fetchStaffCount,
          success: true,
          inProgress: false,
          count: payload?.data
        },
      };
    case ADD_FETCH_ALL_COUNT_STAFF_FAILURE:
      return {
        ...state,
        fetchStaffCount: {
          ...state.fetchStaffCount,
          error: true,
          inProgress: false,
          errorMessage: payload.error,
        },
      };
      
    case GET_PATIENT_COUNT_REQUEST:
      return {
        ...state,
        fetchPatientCount: { ...state.fetchPatientCount, inProgress: true },
      };
    case GET_PATIENT_COUNT_SUCCESS:
      return {
        ...state,
        fetchPatientCount: {
          ...state.fetchPatientCount,
          success: true,
          inProgress: false,
          count: payload?.data
        },
      };
    case GET_PATIENT_COUNT_FAILURE:
      return {
        ...state,
        fetchPatientCount: {
          ...state.fetchPatientCount,
          error: true,
          inProgress: false,
          errorMessage: payload.error,
        },
      };

    case RESET_CURRENT_BLOCK:
      return {
        ...state,
        currentBlock: null,
      };

    default:
      return state;
  }
};

export default DashboardReducer;